import React, { useContext, useEffect, useRef } from 'react'
import { homeLink } from '../constants/endspoints'
import Footer from '../components/Footer'
import BottomMobileNav from '../components/BottomMobileNav'
import Header from '../components/Header'
import { AppContexte } from '../contexts/context'
import HeaderHome from '../components/HeaderHome'
import { TransitionGroup, CSSTransition } from 'react-transition-group'
import { useLocation } from 'react-router-dom'

const UserLayout = ({children}) => {

    const {endPoint} = useContext(AppContexte)

    const { setEndPoint } = useContext(AppContexte);
    const location = useLocation();
    const nodeRef = useRef(null);

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'instant' });
    }, [location]);
    useEffect(() => {
        setEndPoint(location.pathname);
    }, [location, setEndPoint]);



    return (
        <TransitionGroup>
            <CSSTransition key={location.key} timeout={300} classNames="fade" nodeRef={nodeRef}>
                <div ref={nodeRef}>
                    {endPoint === homeLink ? <HeaderHome/> : <Header/>}
                    {children}
                    {endPoint === homeLink ? null : <Footer/>}
                    <BottomMobileNav/>
                </div>
            </CSSTransition>
        </TransitionGroup>
    )
}

export default UserLayout